import styled from 'styled-components';

export const LogoBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
